import { postJSON } from "../helpers/core";

/**
 * Raise a support case in AffinitySupport
 * @param {object} args
 */
export const Create = (args) =>
  postJSON("Affinity/Support/Tickets/Create", args, false);
